// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SingleTripPage_entry-component__yG1sS{
    width: 100vw;
    height: 70vw;
    margin-top: -12vw;
}

.SingleTripPage_entry-img__Jhioh{
    width: 100vw;
    height: 70vw;
    object-fit: cover;
    position: absolute;
    z-index: -1;
}

.SingleTripPage_curator-card-container__TXrtk{
    width: 30vw;
    min-height: 25vw;
    height: auto;
    padding: 1.5vw;
    box-sizing: border-box;
    position: absolute;
    margin-left: 61vw;
    margin-top: 20vw;
    border-radius: 2vw;
    background-color: white;
}

.SingleTripPage_entry-container__N8-R1{
    /* width: 40vw; */
    height:20vw;
    position: absolute;
    margin-top: 19vw;
    margin-left: 7vw;
}

.SingleTripPage_entry-trip-name__UFoJR{
    font-size: 3.7vw;
    margin-top: 0;
    margin-bottom: 0;
}

.SingleTripPage_entry-trip-title__hdr1I{
    font-size: 2.3vw;
    margin-top: 0;
    margin-bottom: 0;
}

.SingleTripPage_entry-button__QX6oP{
    width: 17vw;
    height: 3vw;
    background-color: #e65439;
    border: none;
    color:white;
    margin-top: 1vw;
    font-size: 1.2vw;
    font-weight: bold;
    border-radius: 100vw;
    cursor: pointer;
    font-family: dm-sans-medium;
}

@media(max-width: 768px){
    .SingleTripPage_entry-component__yG1sS{
        width: 100vw;
        min-height: 70vw;
        margin-top: -30vw;
    }
    
    .SingleTripPage_entry-img__Jhioh{
        width: 100vw;
        height: 120vw;
        object-fit: cover;
        position: absolute;
        z-index: -1;
    }
    
    .SingleTripPage_curator-card-container__TXrtk{
        width: 70vw;
        min-height: 95vw;
        height: auto;
        border: 1px solid black;
        padding: 3vw;
        box-sizing: border-box;
        position: absolute;
        margin-left: 15vw;
        margin-top: 85vw;
        border-radius: 5vw;
        background-color: white;
    }
    
    .SingleTripPage_entry-container__N8-R1{
        width: 100vw;
        height:20vw;
        position: absolute;
        margin-top: 35vw;
        margin-left: 0vw;
    }
    
    .SingleTripPage_entry-trip-name__UFoJR{
        font-size: 7vw;
        margin-top: 0;
        margin-bottom: 0;
        text-align: center;
    }
    
    .SingleTripPage_entry-trip-title__hdr1I{
        font-size: 4vw;
        text-align: center;
        margin-top: 1vw;
        margin-bottom: 0;
    }
    
    .SingleTripPage_entry-button__QX6oP{
        width:30vw;
        height: 7vw;
        margin-left: 35vw;
        background-color: #e65439;
        border: none;
        color:white;
        margin-top: 4vw;
        font-size: 4vw;
        font-weight: bold;
        border-radius: 100vw;
        cursor: pointer;

    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/SingleTripPage/SingleTripPage.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI;QACI,YAAY;QACZ,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,iBAAiB;QACjB,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,YAAY;QACZ,uBAAuB;QACvB,YAAY;QACZ,sBAAsB;QACtB,kBAAkB;QAClB,iBAAiB;QACjB,gBAAgB;QAChB,kBAAkB;QAClB,uBAAuB;IAC3B;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,kBAAkB;QAClB,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,aAAa;QACb,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,UAAU;QACV,WAAW;QACX,iBAAiB;QACjB,yBAAyB;QACzB,YAAY;QACZ,WAAW;QACX,eAAe;QACf,cAAc;QACd,iBAAiB;QACjB,oBAAoB;QACpB,eAAe;;IAEnB;AACJ","sourcesContent":[".entry-component{\n    width: 100vw;\n    height: 70vw;\n    margin-top: -12vw;\n}\n\n.entry-img{\n    width: 100vw;\n    height: 70vw;\n    object-fit: cover;\n    position: absolute;\n    z-index: -1;\n}\n\n.curator-card-container{\n    width: 30vw;\n    min-height: 25vw;\n    height: auto;\n    padding: 1.5vw;\n    box-sizing: border-box;\n    position: absolute;\n    margin-left: 61vw;\n    margin-top: 20vw;\n    border-radius: 2vw;\n    background-color: white;\n}\n\n.entry-container{\n    /* width: 40vw; */\n    height:20vw;\n    position: absolute;\n    margin-top: 19vw;\n    margin-left: 7vw;\n}\n\n.entry-trip-name{\n    font-size: 3.7vw;\n    margin-top: 0;\n    margin-bottom: 0;\n}\n\n.entry-trip-title{\n    font-size: 2.3vw;\n    margin-top: 0;\n    margin-bottom: 0;\n}\n\n.entry-button{\n    width: 17vw;\n    height: 3vw;\n    background-color: #e65439;\n    border: none;\n    color:white;\n    margin-top: 1vw;\n    font-size: 1.2vw;\n    font-weight: bold;\n    border-radius: 100vw;\n    cursor: pointer;\n    font-family: dm-sans-medium;\n}\n\n@media(max-width: 768px){\n    .entry-component{\n        width: 100vw;\n        min-height: 70vw;\n        margin-top: -30vw;\n    }\n    \n    .entry-img{\n        width: 100vw;\n        height: 120vw;\n        object-fit: cover;\n        position: absolute;\n        z-index: -1;\n    }\n    \n    .curator-card-container{\n        width: 70vw;\n        min-height: 95vw;\n        height: auto;\n        border: 1px solid black;\n        padding: 3vw;\n        box-sizing: border-box;\n        position: absolute;\n        margin-left: 15vw;\n        margin-top: 85vw;\n        border-radius: 5vw;\n        background-color: white;\n    }\n    \n    .entry-container{\n        width: 100vw;\n        height:20vw;\n        position: absolute;\n        margin-top: 35vw;\n        margin-left: 0vw;\n    }\n    \n    .entry-trip-name{\n        font-size: 7vw;\n        margin-top: 0;\n        margin-bottom: 0;\n        text-align: center;\n    }\n    \n    .entry-trip-title{\n        font-size: 4vw;\n        text-align: center;\n        margin-top: 1vw;\n        margin-bottom: 0;\n    }\n    \n    .entry-button{\n        width:30vw;\n        height: 7vw;\n        margin-left: 35vw;\n        background-color: #e65439;\n        border: none;\n        color:white;\n        margin-top: 4vw;\n        font-size: 4vw;\n        font-weight: bold;\n        border-radius: 100vw;\n        cursor: pointer;\n\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"entry-component": `SingleTripPage_entry-component__yG1sS`,
	"entry-img": `SingleTripPage_entry-img__Jhioh`,
	"curator-card-container": `SingleTripPage_curator-card-container__TXrtk`,
	"entry-container": `SingleTripPage_entry-container__N8-R1`,
	"entry-trip-name": `SingleTripPage_entry-trip-name__UFoJR`,
	"entry-trip-title": `SingleTripPage_entry-trip-title__hdr1I`,
	"entry-button": `SingleTripPage_entry-button__QX6oP`
};
export default ___CSS_LOADER_EXPORT___;
